import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Parallax} from 'react-parallax';
import './breadcrumb.scss';
import {withTranslate} from "react-redux-multilingual";

class Breadcrumb extends Component {

    renderParent(items) {
        const {translate} = this.props;

        return (
            items.map((item, index) =>
                <li className="breadcrumb-item" key={index}>
                    <Link to={`${process.env.PUBLIC_URL}/${item.path}`}>{translate(item.title)}</Link>
                </li>
            )
        )
    }

    render() {
        const {title, translate, bgImage} = this.props;
        let defaultBg = `${process.env.PUBLIC_URL}/assets/imagewebp/breadcrumb/breadcrumb-1.webp`;
        if (bgImage) {
            defaultBg = bgImage;
        }

        return (
            <Parallax className="breadcrumb-section"
                      bgImage={defaultBg}
                      bgImageAlt="the cat"
                      strength={500}
            >
                <div className="container">
                    <div className="page-title">
                        <h2>{translate(title)}</h2>
                    </div>
                    <nav className="theme-breadcrumb">
                        <ol className="breadcrumb">
                        </ol>
                    </nav>
                </div>
            </Parallax>

        )
    }
}

export default withTranslate(Breadcrumb);